/**
 * Every route template the app registers (App.tsx), for the page-view beacon
 * (task #3068; backend docs/usage-stats.md). The beacon sends the TEMPLATE a
 * screen matched, never its address, so ids, tokens, slugs and names never
 * leave the device.
 *
 * `__tests__/routes.test.ts` reads App.tsx and fails if a route is added
 * there without being listed here or in EXCLUDED_ROUTES, so this cannot
 * silently drift.
 */
export const ROUTE_TEMPLATES: readonly string[] = [
  "/",
  "/Activities",
  "/ConversationStarters",
  "/Courses/:slug",
  "/Courses/:slug/answers",
  "/Courses/:slug/:unitKey",
  "/Courses/:slug/:unitKey/worksheet",
  "/IntimacyAdventCalendar",
  "/IntimacyAdventCalendar/Cards",
  "/IntimacyAdventCalendar/CreateCard",
  "/IntimacyAdventCalendar/GeneratePDF",
  "/IntimacyAdventCalendar/Schedule",
  "/IntimacyAdventCalendar/ViewSchedule",
  "/IntimacyInsights",
  "/IntimacyInsights/Stats",
  "/Invite",
  "/Login",
  "/Logout",
  "/OurSexplorationList",
  "/OurSexplorationList/AnswerQuestions/:spouse",
  "/OurSexplorationList/AnswerQuestions/AlreadyAnswered/:spouse",
  "/OurSexplorationList/AnswerQuestions/BySection/:section/:spouse",
  "/OurSexplorationList/AnswerQuestions/InOrder/:spouse",
  "/OurSexplorationList/AnswerQuestions/Random/:spouse",
  "/OurSexplorationList/AnswerQuestions/Set/:count/:spouse",
  "/OurSexplorationList/AnswerQuestions/Specific/:spouse/:questionId/:returnTo",
  "/OurSexplorationList/AnswerQuestions/SpouseAnswered/:spouse",
  "/OurSexplorationList/Directions",
  "/OurSexplorationList/ExplorationGuide",
  "/OurSexplorationList/Export",
  "/OurSexplorationList/FindMatches",
  "/OurSexplorationList/InviteSpouse",
  "/OurSexplorationList/ManageQuestions",
  "/OurSexplorationList/Sessions",
  "/OurSexplorationList/ViewAnswers/:spouse",
  "/Register",
  "/Settings",
  "/Settings/ApiExplorer",
  "/Settings/ManageActivities",
  "/Settings/WhatsNew",
  "/SignIn",
  "/SpontaneousResponsiveQuiz",
  "/advent/:token",
  "/live",
  "/live/:slug",
  "/live/:slug/watch",
];

/**
 * Routes that send no beacon at all. Staff pages are not member usage, and a
 * page only one known person can open (the closed-beta guide) would make its
 * count that person's activity log.
 */
export const EXCLUDED_ROUTES: readonly string[] = [
  "/Admin",
  "/Admin/Courses/:slug",
  "/Admin/CourseQA",
  "/Admin/CourseQA/:slug",
  "/Admin/Webinar",
  "/Admin/Webinar/:slug",
  "/Admin/ManageConversationStarters",
  "/AdminTest",
  "/Analytics",
  "/PrivateGuide",
];
